/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e,s){super(r,"sampler2D",2,(o,t,m)=>o.bindTexture(r,e(t,m),s?.(t,m)))}}export{e as Texture2DDrawUniform};
